const welcome = {
    title: 'Bem-vindo ao Admin Console',
    description: 'O Admin Console é um aplicativo da web para gerenciar o GptHouse sem requisitos de codificação. Vamos primeiro criar uma conta. Com esta conta, você pode gerenciar o GptHouse sozinho ou em nome de sua empresa.',
    create_account: 'Criar uma conta',
};
export default Object.freeze(welcome);
